export const PIN_NAV_PANEL = 'pin_nav_panel'
export const SELECTED_OS = 'selected_os'
export const SELECTED_BIOC_VERSION = 'selected_bioc_version'

export const getLocalState = (key) => {
  const raw = window.localStorage.getItem(key) || null
  return JSON.parse(raw)
}

export const hasLocalState = (key) => {
  const state = getLocalState(key)
  if (state === null) {
    return false
  }
  return true
}

export const setLocalState = (key, value) => {
  window.localStorage.setItem(key, JSON.stringify(value))
}

export const clearLocalState = (key) => {
  window.localStorage.removeItem(key)
}
